import React from 'react';

import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const ReactHookFormSelect = ({
    control,
    disabled,
    fullWidth,
    id,
    label,
    name,
    onChange,
    options,
    sxFormControl,
    variant,
}) => (
    <Controller
        control={control}
        defaultValue={null}
        name={name}
        render={({ field, fieldState: { error } }) => {
            const valueIsBetweenTheOptions = options.filter(
                (option) => option.value === field.value,
            );

            return (
                <FormControl
                    error={Boolean(error)}
                    fullWidth={fullWidth}
                    size="small"
                    variant={variant}
                    {...sxFormControl}
                >
                    <InputLabel
                        {...(field?.value &&
                            valueIsBetweenTheOptions.length && {
                                shrink: Boolean(field.value),
                            })}
                    >
                        {label}
                    </InputLabel>
                    <Select
                        disabled={disabled}
                        displayEmpty={label === ''}
                        id={id}
                        label={label}
                        {...field}
                        onChange={(e) => {
                            field.onChange(e);
                            if (onChange) onChange(e);
                        }}
                        value={
                            field.value !== null &&
                            valueIsBetweenTheOptions.length
                                ? field.value
                                : ''
                        }
                    >
                        {options.map(
                            ({ label, value, disabled: optionDisabled }) => (
                                <MenuItem
                                    key={`select-${value}-${label}`}
                                    value={value}
                                    disabled={optionDisabled}
                                >
                                    {label}
                                </MenuItem>
                            ),
                        )}
                    </Select>

                    {Boolean(error) && (
                        <FormHelperText>{error?.message}</FormHelperText>
                    )}
                </FormControl>
            );
        }}
    />
);

ReactHookFormSelect.defaultProps = {
    fullWidth: true,
    ignore: [],
    label: '',
    sxFormControl: {},
};

ReactHookFormSelect.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    id: PropTypes.string,
    ignore: PropTypes.array,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    required: PropTypes.bool,
    sxFormControl: PropTypes.object,
    variant: PropTypes.string,
};

export default ReactHookFormSelect;
